"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLanguagePairCode = exports.isLanguageCode = exports.isLearnLanguageCode = exports.isKnownLanguageCode = exports.isLanguageCodeWithoutLocale = exports.LanguageModuleSchema = exports.LanguageCodeWithoutLocaleSchema = exports.LanguagePairCodeSchema = exports.LanguageCodeSchema = exports.LearnLanguageCodeSchema = exports.KnownLanguageCodeSchema = exports.learnLanguageCodesLiterals = exports.knownLanguageCodesLiterals = exports.languageCodesWithoutLocale = exports.languageCodes = exports.learnLanguageCodes = exports.knownLanguageCodes = exports.isLatinLanguage = exports.getLearnLanguageName = exports.getLanguagePairCodeFromKnownAndLearnLanguages = exports.getLocaleWithoutLanguage = exports.getLanguageWithoutLocale = exports.getLearnLanguage = exports.getKnownLanguage = exports.partitionLanguageCodes = exports.languagePairCodes = void 0;
const R = __importStar(require("ramda"));
const zod_1 = require("zod");
const typing_utils_1 = require("../typing_utils");
// CONST
exports.languagePairCodes = [
    "en-US_de-DE",
    "en-US_en-US",
    "en-US_es-ES",
    "en-US_es-MX",
    "en-US_fr-FR",
    "en-US_he-IL",
    "en-US_it-IT",
    "en-US_ja-JP",
    "en-US_ko-KR",
    "en-US_nl-NL",
    "en-US_pt-BR",
    "en-US_ru-RU",
    "en-US_zh-CN",
];
// UTILS
const partitionLanguageCodes = (langPairCode) => ({
    known: langPairCode.substring(0, 5),
    learn: langPairCode.substring(6),
});
exports.partitionLanguageCodes = partitionLanguageCodes;
const getKnownLanguage = (langPairCode) => exports.partitionLanguageCodes(langPairCode).known;
exports.getKnownLanguage = getKnownLanguage;
const getLearnLanguage = (langPairCode) => exports.partitionLanguageCodes(langPairCode).learn;
exports.getLearnLanguage = getLearnLanguage;
const getLanguageWithoutLocale = (langCode) => langCode.substring(0, 2);
exports.getLanguageWithoutLocale = getLanguageWithoutLocale;
const getLocaleWithoutLanguage = (langCode) => langCode.substring(3);
exports.getLocaleWithoutLanguage = getLocaleWithoutLanguage;
const getLanguagePairCodeFromKnownAndLearnLanguages = ({ known, learn, }) => {
    const languagePairCode = `${known}_${learn}`;
    return R.includes(languagePairCode, exports.languagePairCodes)
        ? languagePairCode
        : undefined;
};
exports.getLanguagePairCodeFromKnownAndLearnLanguages = getLanguagePairCodeFromKnownAndLearnLanguages;
const LANGUAGE_MAP = {
    "de-DE": "German",
    "en-US": "English",
    "es-ES": "Spanish (Spain)",
    "es-MX": "Spanish (Mexico)",
    "fr-FR": "French",
    "he-IL": "Hebrew",
    "it-IT": "Italian",
    "ja-JP": "Japanese",
    "ko-KR": "Korean",
    "nl-NL": "Dutch",
    "pt-BR": "Portuguese",
    "ru-RU": "Russian",
    "zh-CN": "Mandarin Chinese",
};
const getLearnLanguageName = (langCode) => {
    if (!LANGUAGE_MAP[langCode]) {
        throw new Error(`Invalid language code: [${langCode}]`);
    }
    return LANGUAGE_MAP[langCode];
};
exports.getLearnLanguageName = getLearnLanguageName;
const CODE_IS_LATIN_MAP = {
    "de-DE": true,
    "en-US": true,
    "es-ES": true,
    "es-MX": true,
    "fr-FR": true,
    "he-IL": false,
    "it-IT": true,
    "ja-JP": false,
    "ko-KR": false,
    "nl-NL": true,
    "pt-BR": true,
    "ru-RU": false,
    "zh-CN": false,
};
const isLatinLanguage = (langCode) => CODE_IS_LATIN_MAP[langCode];
exports.isLatinLanguage = isLatinLanguage;
// GENERATED CONSTS
exports.knownLanguageCodes = exports.languagePairCodes.map(exports.getKnownLanguage);
exports.learnLanguageCodes = exports.languagePairCodes.map(exports.getLearnLanguage);
exports.languageCodes = Array.from(new Set([
    ...exports.languagePairCodes.map(exports.getKnownLanguage),
    ...exports.languagePairCodes.map(exports.getLearnLanguage),
]));
exports.languageCodesWithoutLocale = exports.languageCodes.map(exports.getLanguageWithoutLocale);
// ZOD LITERALS
exports.knownLanguageCodesLiterals = typing_utils_1.mapArrayToLiteralTuple(exports.knownLanguageCodes);
exports.learnLanguageCodesLiterals = typing_utils_1.mapArrayToLiteralTuple(exports.learnLanguageCodes);
const languageCodeLiterals = typing_utils_1.mapArrayToLiteralTuple(exports.languageCodes);
const languagePairCodeLiterals = typing_utils_1.mapArrayToLiteralTuple(exports.languagePairCodes);
const languageCodeWithoutLocaleLiterals = typing_utils_1.mapArrayToLiteralTuple(exports.languageCodesWithoutLocale);
// ZOD SCHEMAS
// Update when we support more than 1 known language
exports.KnownLanguageCodeSchema = exports.knownLanguageCodesLiterals[0];
exports.LearnLanguageCodeSchema = zod_1.z.union(exports.learnLanguageCodesLiterals);
exports.LanguageCodeSchema = zod_1.z.union(languageCodeLiterals);
exports.LanguagePairCodeSchema = zod_1.z.union(languagePairCodeLiterals);
exports.LanguageCodeWithoutLocaleSchema = zod_1.z.union(languageCodeWithoutLocaleLiterals);
exports.LanguageModuleSchema = zod_1.z.object({
    code: exports.LanguagePairCodeSchema,
    known_code: exports.KnownLanguageCodeSchema,
    known_lang: zod_1.z.string(),
    known_variant: zod_1.z.string(),
    last_seed_date: zod_1.z.string(),
    learn_code: exports.LearnLanguageCodeSchema,
    learn_lang: zod_1.z.string(),
    learn_variant: zod_1.z.string(),
    name: zod_1.z.string(),
});
// TYPE GUARDS
const isLanguageCodeWithoutLocale = (v) => exports.LanguageCodeWithoutLocaleSchema.safeParse(v).success;
exports.isLanguageCodeWithoutLocale = isLanguageCodeWithoutLocale;
const isKnownLanguageCode = (v) => exports.KnownLanguageCodeSchema.safeParse(v).success;
exports.isKnownLanguageCode = isKnownLanguageCode;
const isLearnLanguageCode = (v) => exports.LearnLanguageCodeSchema.safeParse(v).success;
exports.isLearnLanguageCode = isLearnLanguageCode;
const isLanguageCode = (v) => exports.LanguageCodeSchema.safeParse(v).success;
exports.isLanguageCode = isLanguageCode;
const isLanguagePairCode = (v) => exports.LanguagePairCodeSchema.safeParse(v).success;
exports.isLanguagePairCode = isLanguagePairCode;
//# sourceMappingURL=language_codes_types.js.map